/**
 * product-recommendations-slider
 *
 * Powers the optional slider mode on the "Product recommendations"
 * section, mirroring the Swiper setup used by the Image Cards section.
 *
 * The <product-recommendations> custom element (assets/global.js) fetches
 * its real content asynchronously and replaces its innerHTML once loaded,
 * so slides aren't present at first paint — a MutationObserver re-runs
 * init once that swap happens.
 */
(function () {
  var SWIPER_ATTR = 'data-pr-swiper-initialized';

  function initSlider(root) {
    var scope = root || document;
    var sliders = scope.querySelectorAll ? scope.querySelectorAll('[data-product-recommendations-slider]') : [];

    sliders.forEach(function (slider) {
      if (slider.hasAttribute(SWIPER_ATTR)) return;
      if (typeof window.Swiper === 'undefined') return;

      var wrap = slider.closest('.product-recommendations__slider-wrap');
      var prev = wrap ? wrap.querySelector('[data-pr-prev]') : null;
      var next = wrap ? wrap.querySelector('[data-pr-next]') : null;
      var slidesDesktop = parseInt(slider.dataset.slidesDesktop, 10) || 4;
      // parseFloat, not parseInt — this is intentionally fractional
      // (1.5) so the next slide peeks in as a scroll affordance.
      var slidesMobile = parseFloat(slider.dataset.slidesMobile) || 1.5;
      var spaceBetween = parseInt(slider.dataset.spaceBetween, 10) || 16;

      var config = {
        slidesPerView: slidesMobile,
        spaceBetween: spaceBetween,
        breakpoints: {
          750: { slidesPerView: Math.min(slidesMobile + 1, slidesDesktop) },
          990: { slidesPerView: slidesDesktop }
        }
      };

      if (prev && next) {
        config.navigation = { prevEl: prev, nextEl: next };
      }

      var swiper = new window.Swiper(slider, config);
      slider.__prSwiper = swiper;
      slider.setAttribute(SWIPER_ATTR, 'true');

      // This slider is always initialized on content that just arrived
      // async (MutationObserver-triggered), so the browser may not have
      // finished laying it out yet when Swiper reads the container's
      // width — that can leave slides sized at 0px until something else
      // forces a recalculation. Force a couple of updates once layout
      // has actually settled, then keep watching for size changes.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          swiper.update();
        });
      });

      if (typeof ResizeObserver === 'function') {
        var resizeObserver = new ResizeObserver(function () {
          swiper.update();
        });
        resizeObserver.observe(slider);
      }
    });
  }

  function onReady() {
    initSlider(document);

    document.querySelectorAll('product-recommendations').forEach(function (el) {
      if (el.__prObserverBound) return;
      el.__prObserverBound = true;

      var observer = new MutationObserver(function () {
        initSlider(el);
      });
      observer.observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    onReady();
    initSlider(event.target);
  });
})();
